export { StackedLayout, StackedLayout as default } from "./Stacked";
